/** @format */

import React from "react";
import { Button, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "./TemplateRow.module.css";
import { formatDate, formatTime } from "../../utilities/utilities";
import { downloadCsvApi } from "../../utilities/apis/templates";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { selectUserData } from "../../redux/selectors";
import { useState } from "react";
import { useEffect } from "react";
import { deleteClause } from "../../utilities/apis/clause";
import { FileDownload } from "tabler-icons-react";

function TemplateRow({
  createdBy,
  createdAt,
  name,
  title,
  editButton = false,
  viewButton = true,
  onDelete,
  onViewClick,
  id,
  module,
}) {
  const navigate = useNavigate();
  const userDetails = useSelector(selectUserData);
  // console.log(userDetails?.designation);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (deleteLoading) {
      onDelete(id);
    }
  }, [deleteLoading]);

  const editHandler = () => {
    module === "clause"
      ? navigate(`/app/templates/clause/${id}`)
      : navigate(`/app/templates/edit/template/${id}`);
  };

  const deleteClauseApi = async (id) => {
    try {
      const response = await apiWrapWithErrorWithData(
        deleteClause({ clauseId: id }),
      );
      if (response.success) {
        showNotification({
          color: "green",
          title: "Clause",
          message: "Clause is deleted",
        });
        getClauseLibraryByIdApi();
      } else {
        throw Error(response);
      }
    } catch (error) {
      console.log({ error });
      showNotification({
        color: "red",
        title: "Clause",
        message: "Unable to delete Clause",
      });
    }
    setClauseModalConfig((preState) => ({ ...preState, deleteLoading: false }));
  };
  const downloadCsvHandler = async () => {
    const res = await apiWrapWithErrorWithData(
      downloadCsvApi({ templateId: id }),
    );
    if (res.success) {
      const { data } = res;
      let csvContent = "data:text/csv;charset=utf-8,";

      csvContent += data.fieldName ? data.fieldName?.join(",") : "";

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${data.name}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <div
      className="flex justify-between"
      style={{
        padding: "2px 0",
        alignItems: "center",
      }}
    >
      <div className="flex flex-row">
        <div>
          <FileDownload size={32} strokeWidth={1.7} color="#1971C2" />
        </div>
        <div
          className="flex flex-col"
          style={{
            marginLeft: 14,
          }}
        >
          <Text fw={600} size="sm">
            {name || title}
          </Text>
          <div className="flex flex-row text-center">
            <Text size="xs" c="dimmed">
              Created by {createdBy.name}•{formatDate(createdAt)}•
              {formatTime(createdAt)}
            </Text>
          </div>
        </div>
      </div>
      <div className="flex flex-row">
        {viewButton && (
          <Button
            onClick={onViewClick}
            className="mx-2"
            variant="light"
            radius="xl"
            // color="cyan"
            // style={{
            //   // backgroundColor: '#46BDE1',
            //   color: "#64748B",
            // }}
          >
            View
          </Button>
        )}

        {editButton && (
          <Button
            onClick={editHandler}
            // style={{
            //   backgroundColor: "#46BDE1",
            //   borderRadius: "0.25rem",
            //   height: "40px",
            //   fontWeight: "400",
            //   lineHeight: "1.375rem",
            // }}
            className="mr-2"
            variant="outline"
          >
            Edit
          </Button>
        )}
        {editButton && (
          <Button
            disabled={deleteLoading}
            // style={{
            //   marginRight: "5px",
            //   backgroundColor: deleteLoading ? "#d9d9d9" : "#ff4d4d",
            //   borderRadius: "0.25rem",
            //   height: "40px",
            //   fontWeight: "400",
            //   lineHeight: "1.375rem",
            //   marginLeft: "10px"
            // }}
            variant="filled"
            onClick={() => {
              setDeleteLoading(true);
            }}
          >
            Delete
          </Button>
        )}
        {/* {editButton
            && (
            <Button
              onClick={downloadCsvHandler}
              style={{
                marginLeft: '10px',
                backgroundColor: ' #46BDE1',
                borderRadius: '0.25rem',
                height: '40px',
                fontWeight: '400',
                lineHeight: '1.375rem',
              }}
            >
              CSV download
            </Button>
            )} */}
      </div>
    </div>
  );
}

export default TemplateRow;
